import jQuery from 'jquery';
const $ = jQuery;
import Global from './Global';
function initLang() {
  Global.language = {
    lostTitle: {
      ENG: 'YOU LOST!',
      ARB: 'خسرت!',
    },
    lostTitle2_chocolate: {
      ENG: 'BUT HEY, DARK CHOCOLATE SAYS THANKS FOR THE LIFT.',
      ARB: 'بس لحظة... الدارك يقولك: شكراً على الدعم',
    },
    lostTitle2_hazelnut: {
      ENG: 'BUT HEY, Hazelnut SAYS THANKS FOR THE LIFT.',
      ARB: 'بس لحظة... البندق يقولك: شكراً على الدعم',
    },
    gameScoreInfo_hazelnut: {
      ENG: 'OREO CREDITS TO HAZELNUT',
      ARB: 'نقطة أوريو للبندق',
    },
    gameScoreInfo_chocolate: {
      ENG: 'OREO CREDITS TO Dark chocolate',
      ARB: 'نقطة أوريو للدارك',
    },
    voteNow: {
      ENG: 'VOTE NOW',
      ARB: 'صوت الآن',
    },
    leaderResult: {
      ENG: 'NOW CROSS YOUR FINGERS & <br/>CRUMBS FOR A SPECIAL PRIZE!',
      ARB: `
      الحين تحتاج شوية حظ واختيار
       صح وأكيد الجائزة من نصيبك!
      `,
    },
    instOne: {
      ENG: 'Join the biggest, most flavorful battle between two exciting new Oreo flavors!',
      ARB: 'غامر مع أكبر وألذ منافسة بين أجدد نكهات أوريو',
    },
    instTwo: {
      ENG: 'Cast your vote for your favorite and play along for a chance to catch your favorite in action - and win exciting prizes!',
      ARB: 'نكهتك تحتاج صوتك... واختيارك يمكن يربحك! صوّت لنكهة أوريو المفضلة عندك، وادخل عالم المرح والجوائز المميزة.',
    },
    instThree: {
      ENG: '"Your favorite flavor needs you...Push your pick to the top of the leaderboard!"',
      ARB: 'غامر مع أكبر وألذ منافسة بين أجدد نكهات أوريو',
    },
    instFour: {
      ENG: "Bag a prize while you're at it.",
      ARB: 'ومع كل قرشة... يمكن تطلع بجائزة!',
    },
    play: {
      ENG: 'PLAY',
      ARB: 'العب',
    },
    start_btn: {
      ENG: 'START',
      ARB: 'ابدأ!',
    },
    leaderboard_btn: {
      ENG: 'Cookie Leaderboard',
      ARB: 'ترتيب الكوكيز',
    },
    playToWin_btn: {
      ENG: 'Play to Win',
      ARB: 'العب لتربح',
    },
    what: {
      ENG: 'Whats going on?',
      ARB: 'إيش صار؟',
    },

    how: {
      ENG: 'How to pick a side?',
      ARB: 'بصف مين إنت؟',
    },

    howToPlayGame: {
      ENG: 'How to play?',
      ARB: 'كيف تشارك؟',
    },

    tnc: {
      ENG: 'Not-so-fun-stuff',
      ARB: 'بعيد عن المزح',
    },
    faq: {
      ENG: 'cookie talk',
      ARB: 'سوالف الكوكيز',
    },
    gotoSignUp_btn: {
      ENG: 'SIGN UP',
      ARB: 'انشاء حساب',
    },
    gotoSignIn_btn: {
      ENG: 'SIGN IN',
      ARB: 'تسجيل الدخول',
    },
    formTitle: {
      ENG: 'SIGN UP',
      ARB: 'انشاء حساب',
    },
    nameText: {
      ENG: 'Name',
      ARB: 'الاسم',
    },
    nameErrorText: {
      ENG: 'Enter a valid name',
      ARB: 'يرجى التأكد من الاسم',
    },
    emailText: {
      ENG: 'Email',
      ARB: 'البريد الإلكتروني',
    },
    emailErrorText: {
      ENG: 'Enter your email',
      ARB: 'أدخل عنوان البريد الإلكتروني',
    },
    emailValidErrorText: {
      ENG: 'Enter a valid email',
      ARB: 'يرجى التأكد من عنوان البريد الالكتروني',
    },
    countryText: {
      ENG: 'Country',
      ARB: 'البلد',
    },
    countryErrorText: {
      ENG: 'Select your country',
      ARB: 'اختر بلدك',
    },
    phoneText: {
      ENG: 'Phone Number',
      ARB: 'رقم الهاتف',
    },
    phoneErrorText: {
      ENG: 'Enter your phone number',
      ARB: 'يرجى التأكد من رقم الهاتف',
    },
    phoneValidErrorText: {
      ENG: 'Enter a valid phone number.',
      ARB: 'يرجى التأكد من رقم الهاتف',
    },
    oreoText: {
      ENG: 'When that Oreo craving hits, which pack do you grab?',
      ARB: 'يوم تشتهي أوريو... تختار الروقان ولا المغامرة؟',
    },
    signUpErrorDis: {
      ENG: 'Tap Sign In to jump back in.',
      ARB: 'سجل دخول وعيش الجو الكووول',
    },
    signUpError_btn: {
      ENG: 'SIGN IN',
      ARB: 'تسجيل الدخول',
    },
    signinTitle: {
      ENG: 'SIGN IN',
      ARB: 'تسجيل الدخول',
    },
    tapToTwist_btn: {
      ENG: 'TAP TO TWIST YOUR FLAVOR',
      ARB: 'اضغط لتفك وتشوف نكهتك المفضلة',
    },
    emailTextSignIn: {
      ENG: 'Email',
      ARB: 'البريد الإلكتروني',
    },
    phoneTextSignIn: {
      ENG: 'Phone Number',
      ARB: 'رقم الهاتف',
    },
    signin_btn: {
      ENG: 'SIGN IN',
      ARB: 'تسجيل الدخول',
    },
    submit_btn: {
      ENG: 'SIGN UP',
      ARB: 'تسجيل الدخول',
    },
    signinErrorDis: {
      ENG: 'Tap Sign Up to join the game.',
      ARB: 'اضغط على انشاء حساب لتلعب',
    },
    Oneplayer_btn: {
      ENG: '1 PLAYER',
      ARB: 'لاعب واحد',
    },
    Twoplayer_btn: {
      ENG: '2 PLAYER',
      ARB: 'لاعبين',
    },
    signUpToPlay_btn: {
      ENG: 'SIGN UP TO PLAY',
      ARB: 'أنشئ حساب لتلعب',
    },
    selectFlavourNext_btn: {
      ENG: 'NEXT',
      ARB: 'التالي',
    },
    lookAroundhazelnut: {
      ENG: 'Look around! Hazelnut Oreos are hiding',
      ARB: 'فتّح عيونك! أوريو البندق يلاعبك غميضة',
    },
    lookAroundchocolate: {
      ENG: 'Look around! Dark Chocolate Oreos are hiding',
      ARB: 'فتّح عيونك! أوريو الشوكولاتة الداكنة يلاعبك غميضة',
    },
    tapQuickly: {
      ENG: 'Tap quickly',
      ARB: 'امسكه بسرعة',
    },
    beatTheTime: {
      ENG: 'Beat the clock',
      ARB: 'عينك على الوقت',
    },
    gameInst_btn: {
      ENG: 'PLAY',
      ARB: 'ابدأ',
    },
    backToHomeResult_btn: {
      ENG: 'Back to Home',
      ARB: 'العودة للشاشة الرئيسية',
    },
    reader: {
      ENG: 'Scan. Twist. See who grabs more Oreos.',
      ARB: 'امسح الكود... وفكّها وشوف مين جمّع أوريو أكثر.',
    },
    legend: {
      ENG: 'YOU LEGEND!',
      ARB: 'أنت بطل!',
    },
    draw: {
      ENG: "YOU'RE IN THE DRAW<br/>PRIZES INCOMING!",
      ARB: 'مبروك... اسمك دخل السحب... والجوائز بالطريق!',
    },
    backToHomeScore_btn: {
      ENG: 'Back to Home',
      ARB: 'العودة للشاشة الرئيسية',
    },
    age: {
      ENG: 'I agree that I am above 13 years of age.',
      ARB: 'أوافق على أنني فوق 13 عامًا',
    },
    promotion: {
      ENG: ' I would like to receive promotional communication from Mondelez about its products and offers.',
      ARB: 'أود أن أستقبل الاتصالات الترويجية من موندليز حول منتجاتها وعروضها',
    },
    terms: {
      ENG: '<span>I accept the <span class="tc" style="cursor: pointer;"><u>T&amp;C</u></span> and <span class="pc2" style="cursor: pointer;"><u>Privacy Notice</u></span> of Mondelez and consent to Mondelez using my personal information as stated in the <span class="tc2" style="cursor: pointer;"><u>T&amp;Cs</u></u></span> and <span id="pc" class="pc3" style="cursor: pointer;"><u>Privacy Notice.</u></span></b></span>',
      ARB: `<span class="tc1" style="text-align: right;">
      أوافق على <span class="tc" style="text-decoration: underline; cursor: pointer;">الشروط والأحكام</span>
      وإشعار الخصوصية لشركة موندليز وأوافق على أن تستخدم موندليز معلوماتي الشخصية كما هو مبين في
      <span class="tc">شروط الاستخدام</span> و
      <span id="pc" class="pc3" style="text-decoration: underline; cursor: pointer;">إشعار الخصوصية</span>.
    </span>`,
    },

    or: {
      ENG: 'OR',
      ARB: 'أو',
    },
    backText: {
      ENG: 'BACK',
      ARB: 'خلف',
    },
    nameError: {
      ENG: 'Enter a valid name',
      ARB: 'يرجى التأكد من الاسم',
    },
    emailError: {
      ENG: 'Emter your email',
      ARB: 'أدخل عنوان البريد الإلكتروني',
    },
    emailErrorValid: {
      ENG: 'Enter a valid email',
      ARB: 'يرجى التأكد من عنوان البريد الالكتروني',
    },
    countryError: {
      ENG: 'Select your country',
      ARB: 'اختر بلدك',
    },
    mobileError: {
      ENG: 'Enter your phone number',
      ARB: 'ادخل رقم الهاتف',
    },
    mobileErrorValid: {
      ENG: 'Enter a valid phone number.',
      ARB: 'يرجى التأكد من رقم الهاتف',
    },
    tcError: {
      ENG: 'Please accept terms and conditions',
      ARB: 'الرجاء قبول الشروط والأحكام',
    },
    ageError: {
      ENG: 'Please agree that you are above 13 years',
      ARB: 'يرجى الموافقة على أن عمرك يزيد عن 13 عامًا',
    },
    packError: {
      ENG: 'Please select pack',
      ARB: 'الرجاء تحديد الحزمة',
    },
    join: {
      ENG: 'join',
      ARB: 'joinARB',
    },
    signupsigninImg: {
      ENG: 'Sign-up-or-Sign-in',
      ARB: 'Sign-up-or-Sign-inARB',
    },
    hazelnutImgRight: {
      ENG: 'Chocolate-Hazelnut-flavor-popup-B',
      ARB: 'Chocolate-Hazelnut-flavor-popup-BARB',
    },
    chocolateImgLeft: {
      ENG: 'Dark-chocolate-Flavor-pop-up-B',
      ARB: 'Dark-chocolate-Flavor-pop-up-BARB',
    },
    metBefore: {
      ENG: 'We-met-Before',
      ARB: 'We-met-BeforeARB',
    },
    firstTime: {
      ENG: 'First-time-twisting',
      ARB: 'First-time-twistingARB',
    },
    pickYourSide: {
      ENG: 'Pick-your-side',
      ARB: 'Pick-your-sideARB',
    },
    howToPlayImg: {
      ENG: 'How-to-play',
      ARB: 'How-to-playARB',
    },

    hazelnutImgLeft: {
      ENG: 'Hazelnut-Flavor-pop-up A',
      ARB: 'Hazelnut-Flavor-pop-up-AARB',
    },
    chocolateImgRight: {
      ENG: 'Dark-chocolate-Flavor-pop-up_A',
      ARB: 'Dark-chocolate-Flavor-pop-up_AARB',
    },
    youHaveChoosen: {
      ENG: "You've-choosen-your-flavor-champ",
      ARB: "You've-choosen-your-flavor-champARB",
    },
    scannerTitleImg: {
      ENG: 'Twist-battle-2-player-needed',
      ARB: 'Twist-battle-2-player-neededARB',
    },
    playerNameSubmit_btn: {
      ENG: 'SUBMIT',
      ARB: 'يُقدِّم',
    },
    justSoWeKnowImg: {
      ENG: 'Just-so-we-know-to-crown-cookie-champ',
      ARB: 'Just-so-we-know-to-crown-cookie-champARB',
    },
    playerNamePlaceHolder: {
      ENG: 'Enter your email',
      ARB: 'أدخل عنوان البريد الإلكتروني',
    },
    whatsGoingOnDis: {
      ENG: '  Two new Oreo flavors are going head-to-head and it’s time for you to pick your side! Cast your vote, cheer on your fave and join the flavor packed fun for a chance to score some sweet prizes!',
      ARB: 'نكهتان جديدتان من أوريو تتنافسان بقوة، وحان وقت اختيار نكهتك المفضلة! صوّت، شجّع نكهتك المفضلة، وانضم إلى المرح والنكهات الممتعة لفرصة ربح جوائز قيّمة!',
    },
    howToPickASideDis: {
      ENG: 'Team Dark or Nutty – which side are you on? Pick your flavor and help them win the tastiest debate ever!',
      ARB: 'فريق الظلام أم فريق الجوز - إلى أي جانب أنت؟ اختر نكهتك المفضلة وساعدهم على الفوز في أروع مناظرة على الإطلاق!',
    },
    howToPlayDis: {
      ENG: 'Jump into the game and collect your chose flavor – Dark or Nutty. Tap, tap and stay loyal to your pick to rack up points and win sweet prizes! But hurry.. The flavor frenzy is on a timer!',
      ARB: 'انضم إلى اللعبة واجمع نكهتك المفضلة - داكنة أو جوزية. انقر، انقر، وحافظ على ولائك لاختيارك لتجميع النقاط والفوز بجوائز قيّمة! لكن سارع.. جنون النكهات على مهل!',
    },
    // loginOrRegister:{
    //     'ENG':'',
    //     'ARB':''
    // },
    // loginOrRegister:{
    //     'ENG':'',
    //     'ARB':''
    // },
    // loginOrRegister:{
    //     'ENG':'',
    //     'ARB':''
    // },
    // loginOrRegister:{
    //     'ENG':'',
    //     'ARB':''
    // },
    // loginOrRegister:{
    //     'ENG':'',
    //     'ARB':''
    // },
    // loginOrRegister:{
    //     'ENG':'',
    //     'ARB':''
    // },
  };
}
function changeLanguage() {
  //
  if (Global.lang == 'ENG') {
    document.querySelector('.timer .label').classList.remove('ar');
  } else {
    document.querySelector('.timer .label').classList.add('ar');
  }
  document.querySelector('#scoreLooser_scr .content .header').innerHTML =
    Global.language.lostTitle[Global.lang];
  if (
    Global.collectableType &&
    Global.language[`gameScoreInfo_${Global.collectableType}`]
  ) {
    document.querySelector('#score_scr .content .type').innerHTML =
      Global.language[`gameScoreInfo_${Global.collectableType}`][Global.lang];

    document.querySelector('#scoreLooser_scr .content .dis').innerHTML =
      Global.language[`lostTitle2_${Global.collectableType}`][Global.lang];
  }

  document.querySelector('#voteNow .label').innerHTML = `${
    Global.language.voteNow[Global.lang]
  }`;

  document.querySelector('#result_scr .dis').innerHTML = `${
    Global.language.leaderResult[Global.lang]
  }`;
  document
    .querySelector('#selectionNext')
    .querySelector('.label').innerHTML = `${
    Global.language.selectFlavourNext_btn[Global.lang]
  }`;

  document.querySelector('.instOne').innerHTML = `${
    Global.language.instOne[Global.lang]
  }`;

  document.querySelector('.instTwo').innerHTML = `${
    Global.language.instTwo[Global.lang]
  }`;
  document.querySelector('.instThree').innerHTML = `${
    Global.language.instThree[Global.lang]
  }`;
  document.querySelector('.instFour').innerHTML = `${
    Global.language.instFour[Global.lang]
  }`;
  document.querySelector('#start_btn').querySelector('.btn_txt').innerHTML = `${
    Global.language.start_btn[Global.lang]
  }`;
  document
    .querySelector('#leaderboard_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.leaderboard_btn[Global.lang]
  }`;
  document
    .querySelector('#playToWin_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.playToWin_btn[Global.lang]
  }`;
  document.querySelector('#what').innerHTML = `${
    Global.language.what[Global.lang]
  }`;
  document.querySelector('#how').innerHTML = `${
    Global.language.how[Global.lang]
  }`;
  document.querySelector('#howToPlayGame').innerHTML = `${
    Global.language.howToPlayGame[Global.lang]
  }`;
  document.querySelector('#tnc').innerHTML = `${
    Global.language.tnc[Global.lang]
  }`;
  document.querySelector('#faq').innerHTML = `${
    Global.language.faq[Global.lang]
  }`;
  document
    .querySelector('#gotoSignUp_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.gotoSignUp_btn[Global.lang]
  }`;
  document
    .querySelector('#gotoSignIn_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.gotoSignIn_btn[Global.lang]
  }`;
  document.querySelector('.formTitle').innerHTML = `${
    Global.language.formTitle[Global.lang]
  }`;
  document.querySelector('.nameText').innerHTML = `${
    Global.language.nameText[Global.lang]
  }`;
  document.querySelector('.emailText').innerHTML = `${
    Global.language.emailText[Global.lang]
  }`;
  document.querySelector('.countryText').innerHTML = `${
    Global.language.countryText[Global.lang]
  }`;
  document.querySelector('.phoneText').innerHTML = `${
    Global.language.phoneText[Global.lang]
  }`;
  document.querySelector('.oreoText').innerHTML = `${
    Global.language.oreoText[Global.lang]
  }`;
  document
    .querySelector('#submit_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.submit_btn[Global.lang]
  }`;
  document
    .querySelector('.errorBox.signupError')
    .querySelector('.dis').innerHTML = `${
    Global.language.signUpErrorDis[Global.lang]
  }`;
  document
    .querySelector('#playerNameSubmit_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.playerNameSubmit_btn[Global.lang]
  }`;
  document
    .querySelector('.errorBox.signinError')
    .querySelector('.dis').innerHTML = `${
    Global.language.signinErrorDis[Global.lang]
  }`;
  document
    .querySelector('#signUpError_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.signUpError_btn[Global.lang]
  }`;
  document.querySelector('.signinTitle').innerHTML = `${
    Global.language.signinTitle[Global.lang]
  }`;
  document
    .querySelector('#tapToTwist_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.tapToTwist_btn[Global.lang]
  }`;
  document.querySelector('.emailTextSignIn').innerHTML = `${
    Global.language.emailTextSignIn[Global.lang]
  }`;
  document.querySelector('.phoneTextSignIn').innerHTML = `${
    Global.language.phoneTextSignIn[Global.lang]
  }`;
  document
    .querySelector('#signin_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.signin_btn[Global.lang]
  }`;
  document
    .querySelector('#Oneplayer_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.Oneplayer_btn[Global.lang]
  }`;
  document
    .querySelector('#signInError_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.submit_btn[Global.lang]
  }`;
  document
    .querySelector('#Twoplayer_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.Twoplayer_btn[Global.lang]
  }`;
  document
    .querySelector('#signUpToPlay_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.signUpToPlay_btn[Global.lang]
  }`;
  document
    .querySelector('#selectFlavourNext_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.selectFlavourNext_btn[Global.lang]
  }`;

  if (Global.collectableType) {
    document.querySelector('.lookAround').innerHTML = `${
      Global.language[`lookAround${Global.collectableType}`][Global.lang]
    }`;
    document.querySelector('.cookie_container .inside').innerHTML = `${
      Global.language[`lookAround${Global.collectableType}`][Global.lang]
    }`;
  }

  document.querySelector('.tapQuickly').innerHTML = `${
    Global.language.tapQuickly[Global.lang]
  }`;
  document.querySelector('.beatTheTime').innerHTML = `${
    Global.language.beatTheTime[Global.lang]
  }`;
  document
    .querySelector('#gameInst_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.gameInst_btn[Global.lang]
  }`;
  document
    .querySelector('#backToHomeResult_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.backToHomeResult_btn[Global.lang]
  }`;
  document
    .querySelector('#backToHomeScore_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.backToHomeScore_btn[Global.lang]
  }`;
  document
    .querySelector('#backToHomeScoreLooser_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.backToHomeScore_btn[Global.lang]
  }`;
  document
    .querySelector('#backToHomeResult_btn')
    .querySelector('.btn_txt').innerHTML = `${
    Global.language.backToHomeResult_btn[Global.lang]
  }`;
  document.querySelector('#reader').innerHTML = `${
    Global.language.reader[Global.lang]
  }`;
  document.querySelector('#score_scr').querySelector('.header').innerHTML = `${
    Global.language.legend[Global.lang]
  }`;
  document.querySelector('#score_scr').querySelector('.header').innerHTML = `${
    Global.language.legend[Global.lang]
  }`;
  document.querySelector('#score_scr').querySelector('.dis').innerHTML = `${
    Global.language.draw[Global.lang]
  }`;
  document.querySelector('.c1').querySelector('.terms').innerHTML = `${
    Global.language.terms[Global.lang]
  }`;
  document.querySelector('.c2').querySelector('.terms').innerHTML = `${
    Global.language.promotion[Global.lang]
  }`;
  document.querySelector('.c3').querySelector('.terms').innerHTML = `${
    Global.language.age[Global.lang]
  }`;
  // document.querySelector('.loginC1').querySelector('.terms').innerHTML = `${
  //   Global.language.terms[Global.lang]
  // }`;
  // document.querySelector('.loginC2').querySelector('.terms').innerHTML = `${
  //   Global.language.promotion[Global.lang]
  // }`;
  // document.querySelector('.loginC3').querySelector('.terms').innerHTML = `${
  //   Global.language.age[Global.lang]
  // }`;
  document.querySelector('.or').innerHTML = `${
    Global.language.or[Global.lang]
  }`;
  $('#backText').innerHTML = `${Global.language.backText[Global.lang]}`;
  document.querySelector('#whatsGoingOnHeader').innerHTML = `${
    Global.language.what[Global.lang]
  }`;
  document.querySelector('#howToPickASideHeader').innerHTML = `${
    Global.language.how[Global.lang]
  }`;
  document.querySelector('#howToPlayHeader').innerHTML = `${
    Global.language.howToPlayGame[Global.lang]
  }`;

  document.querySelector('#whatsGoingOnDis').innerHTML = `${
    Global.language.whatsGoingOnDis[Global.lang]
  }`;
  document.querySelector('#howToPickASideDis').innerHTML = `${
    Global.language.howToPickASideDis[Global.lang]
  }`;
  document.querySelector('#howToPlayDis').innerHTML = `${
    Global.language.howToPlayDis[Global.lang]
  }`;

  $('.backText').html(`${Global.language.backText[Global.lang]}`);

  $('.backText').html(Global.language.backText[Global.lang]);
  document.querySelector('#errorLogin').innerHTML =
    Global.language[Global.signInError][Global.lang];
  document.querySelector('#error').innerHTML =
    Global.language[Global.signUpError][Global.lang];

  document.querySelector('#errorPlayerName').innerHTML =
    Global.language.nameError[Global.lang];
  document.getElementById('playerName').placeholder =
    Global.language.playerNamePlaceHolder[Global.lang];
  if (Global.lang === 'ARB') {
    document.querySelector('html').setAttribute('dir', 'rtl');
    document.querySelector('html').setAttribute('lang', 'ar');
    document.body.style.fontFamily = "'Tajawal', sans-serif";
    $('.terms').addClass('active');
    // OR more forcefully for all elements
    document.querySelectorAll('*').forEach((el) => {
      if (
        !el.closest('.en') &&
        !el.closest('.headerEng') &&
        el.tagName !== 'INPUT' &&
        el.tagName !== 'SELECT'
      ) {
        el.style.fontFamily = 'arabic';
      }
    });
    $('.lable').css('text-align', 'right');
    $('select').css('background-position', 'left 0.75em center');
    $('#phoneCodeSignIn').css('background-position', 'left 0.75em center');
    $('select').css('padding-left', '1%');
  } else {
    $('.terms').removeClass('active');
    $('select').css('background-position', 'right 0.75em center');
    $('select').css('padding-right', '1%');
    $('#phoneCodeSignIn').css('background-position', 'left 0.75em center');

    document.querySelector('html').setAttribute('dir', 'initial');
    document.querySelector('html').setAttribute('lang', 'en');
    document.querySelectorAll('*').forEach((el) => {
      el.style.removeProperty('font-family');
    });
    $('.lable').css('text-align', 'left');
  }
  $('.pc2').on('click', () => {
    window.open('https://www.oreostayplayful.com/privacy-policy/', '_blank');
  });
  $('.pc').on('click', () => {
    window.open('https://www.oreostayplayful.com/privacy-policy/', '_blank');
  });
  $('.pc3').on('click', () => {
    window.open('https://www.oreostayplayful.com/privacy-policy/', '_blank');
  });
  $('#pc').on('click', () => {
    window.open('https://www.oreostayplayful.com/privacy-policy/', '_blank');
  });

  $('.tc, .tc2').on('click', function () {
    $('.menuBox').hide();
    document
      .querySelectorAll('.UAEENG, .UAEARB, .BHRENG, .BHRARB,.KSAENG, .KSAARB')
      .forEach((el) => {
        el.style.display = 'none';
      });
    $('#termsAndConditions').show();

    setTimeout(() => {
      if (Global.country == 'UAE') {
        document.querySelector(`.UAE${Global.lang}`).style.display = 'block';
      } else if (Global.country == 'KSA') {
        document.querySelector(`.KSA${Global.lang}`).style.display = 'block';
      } else {
        document.querySelector(`.BHR${Global.lang}`).style.display = 'block';
      }
    }, 50);
    $('#menuPopup_scr').css('display', 'flex');

    setTimeout(function () {
      $('#menuPopup_scr').addClass('active');
    }, 50);
  });
  Global.events.dispatchEvent({
    type: 'GAME_EVENTS',
    message: {
      event_type: 'update_language',
      data: {},
    },
  });
}

export { initLang, changeLanguage };
